import useApi from "../../../../../../utils/api";
import useSWRMutation from "swr/mutation";

export const useResetOverride = (userId) => {
    const { authPut } = useApi();

    return useSWRMutation(
        `/time-sheet/${userId}/overrides/reset`,
        (url, { arg }) => {
            return authPut(url, { data: arg });
        },
    );
}
